<div mat-dialog-title class="dialog-title p-3 pr-5 clearfix">
  <h5>
    {{ utils.getLangTerm('employees.plural', 'Employees') }} {{ dataSource.multiple ? '(' + dataSource.selection.selected.length + ')' : '' }}
  </h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <form class="form-inline my-2 my-lg-0 float-lg-right" (ngSubmit)="dataSource.getData(true)">
    <input
      class="form-control mr-2 my-1"
      type="search"
      [(ngModel)]="dataSource.search"
      name="search"
      placeholder="Search {{ utils.getLangTerm('employees.plural', 'Employees') }}" />

    <button mat-raised-button color="secondary" class="mr-2 my-1" type="submit">
      <mat-icon>search</mat-icon> Search
    </button>
  </form>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <table mat-table [dataSource]="dataSource" matSort
         matSortActive="contact_person" matSortDirection="asc" matSortDisableClear>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="accounts.name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Company Name</th>
      <td mat-cell *matCellDef="let element">{{ element.company_name }}</td>
    </ng-container>

    <ng-container matColumnDef="contact_person">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Full Name
      </th>
      <td mat-cell *matCellDef="let element">
        <a (click)="onUserPublicView(element.hash, $event)"
           matTooltip="View User Public Profile">
          {{ element.contact_person }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email Address</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>

    <ng-container matColumnDef="mobile">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number</th>
      <td mat-cell *matCellDef="let element">{{ element.mobile }}</td>
    </ng-container>

    <ng-container matColumnDef="users.iqp_number">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>IQP Number</th>
      <td mat-cell *matCellDef="let element">{{ element.iqp_number || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Joined</th>
      <td mat-cell *matCellDef="let element">{{ (element.date_created * 1000) | timezoneConvertMedium }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-raised-button
          color="primary"
          (click)="onSelectSingle(element.id)"
          *ngIf="!this.dataSource.isSelected(element.id)">
          Select
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="dataSource.toggleRowSelection(row.id)">
    </tr>
  </table>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-2 py-1">
  <mat-paginator
    #paginator
    class="my-2 ml-1 mr-2"
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>

  <button
    mat-raised-button
    class="my-2 ml-1 mr-2"
    color="primary"
    (click)="onSelectMultiple()"
    *ngIf="data['multiple']">
    Select
  </button>

  <button
    mat-raised-button
    class="my-2 ml-1 mr-2"
    color="secondary"
    (click)="onSelectAllRecords()"
    *ngIf="dataSource.isAllSelected() && (dataSource.selection.selected.length != paginator.length)">
    Select All ({{paginator.length}})
  </button>

  <button
    mat-raised-button
    class="my-2 ml-1 mr-2"
    color="secondary"
    (click)="onDeselectAllRecords()"
    *ngIf="dataSource.selection.selected.length > paginator.pageSize">
    Deselect All
  </button>

  <button
    mat-raised-button
    class="my-2 ml-1 mr-2"
    color="secondary"
    (click)="onDeselectSingle()"
    *ngIf="!data['multiple'] && data['selected'].length > 0 && data['deselect']">
    Deselect {{ utils.getLangTerm('employees.singular', 'Employee') }}
  </button>
</mat-dialog-actions>
